/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Move_Item_Dialog_TitleInputs */



/**
* | type | output |
* | --- | --- |
* | "airHandlerUnit" | "Move ventilation units" |
* | "boilerRoom" | "Move boilers" |
* | "gateway" | "Move gateways" |
* | "multisensor" | "Move multisensors" |
* | "room" | "Move rooms" |
* | "valve" | "Move thermostatic heads" |
* | * | "Move rooms" |
*
* @param {Move_Item_Dialog_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const move_item_dialog_title = /** @type {((inputs: Move_Item_Dialog_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Move_Item_Dialog_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.type === "airHandlerUnit") return /** @type {LocalizedString} */ (`Move ventilation units`);
		if (i?.type === "boilerRoom") return /** @type {LocalizedString} */ (`Move boilers`);
		if (i?.type === "gateway") return /** @type {LocalizedString} */ (`Move gateways`);
		if (i?.type === "multisensor") return /** @type {LocalizedString} */ (`Move multisensors`);
		if (i?.type === "room") return /** @type {LocalizedString} */ (`Move rooms`);
		if (i?.type === "valve") return /** @type {LocalizedString} */ (`Move thermostatic heads`);
		return /** @type {LocalizedString} */ (`Move rooms`)
	}
	{
		if (i?.type === "airHandlerUnit") return /** @type {LocalizedString} */ (`Déplacer des équipements de ventilation`);
		if (i?.type === "boilerRoom") return /** @type {LocalizedString} */ (`Déplacer des chaudières`);
		if (i?.type === "gateway") return /** @type {LocalizedString} */ (`Déplacer des box`);
		if (i?.type === "multisensor") return /** @type {LocalizedString} */ (`Déplacer des multicapteurs`);
		if (i?.type === "room") return /** @type {LocalizedString} */ (`Déplacer des pièces`);
		if (i?.type === "valve") return /** @type {LocalizedString} */ (`Déplacer des têtes thermostatiques`);
		return /** @type {LocalizedString} */ (`Déplacer des pièces`)
	}
});